
import Vue from 'vue'
import { ERROR_RESPONSE_DIALOG_DATA, SHOW_ERROR_RESPONSE_DIALOG } from '@/store/getter-types'
import { HIDE_RESPONSE_ERROR_DIALOG } from '@/store/action-types'

export default Vue.extend({
  name: 'ErrorResponseDialog',

  computed: {
    showDialog (): boolean {
      return this.$store.getters[SHOW_ERROR_RESPONSE_DIALOG]
    },

    data (): any {
      return this.$store.getters[ERROR_RESPONSE_DIALOG_DATA]
    }
  },

  methods: {
    onCloseButtonClick (): void {
        this.$store.dispatch(HIDE_RESPONSE_ERROR_DIALOG)
    }
  }
})
